export default {
  TITLE: "Are you sure?",
  BTN_CONFIRM: "Close chat",
  BTN_CANCEL: "Cancel"
};